function Published2022() {

    return (
      <>
        <div className="ml-10 mt-5">
          <div className="flex">
            <div className="w-1/6 text-center">2022</div>

            <div className="w-full">
                <div className="flex">
                    <div className="w-full">
                        <p>M. Kim, <a href="https://www.intlpress.com/site/pub/pages/journals/items/atmp/content/vols/0026/0010/a007/" target="_blank" className="text-sky-600">“A generalization of Dijkgraaf-Witten theory.”</a></p>
                        <p>Advances in Theoretical and Mathematical Physics 26.10 (2022): 3677-3719.</p>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </>
    );
  }
  
  export default Published2022;